import React from 'react';
import { Drawer } from 'clad-ui';
import Image from 'next/image';
import { POPUP_ICON_URL } from '~/constants';
type Props = {
  open?: boolean;
  onClose?: () => void;
  data: {
    ban_date: string;
    ban_expiry: string;
    ban_message: string[];
    ban_code: string[];
  } | null;
};
const BanPopup = (props: Props) => {
  const {
    open,
    onClose,
    data
  } = props;
  const onKnowMore = () => {
    window.open('https://trogiup.chotot.com/nguoi-ban/hoat-dong/', '_blank');
  };
  return <Drawer primaryBtnLabel="Tìm hiểu thêm" open={open} onClose={onClose} onPrimaryButtonClick={onKnowMore} title="Thông báo">
      <div className={containerCss}>
        <Image width={80} height={80} className={iconCss} src={POPUP_ICON_URL.error} alt="error" />
        <h4 className={titleCss}>
          {!data?.ban_expiry || data?.ban_expiry === '01/01/9999' ? 'Tài khoản đã bị khóa' : <>
              Tài khoản đã bị tạm khóa
              <br />
              (từ ngày {data?.ban_date} đến ngày {data?.ban_expiry})
            </>}
        </h4>

        {data?.ban_message ? <>
            <p>
              Bạn không thể đăng nhập Chợ Tốt do Tài khoản đã vi phạm Quy định và Tiêu chuẩn cộng
              đồng khi hoạt động trên Chợ Tốt như sau:
            </p>
            <ul>
              {data.ban_message.map((message, index) => <li key={message}>
                  {`${message} ${data.ban_code[index] ? `(${data.ban_code[index]})` : ''}`}
                </li>)}
            </ul>
          </> : null}
        <p>
          Mọi thắc mắc vui lòng gửi email về hòm thư:
          <br />
          <a id="support-link" href="mailto:trogiup@chotot.vn">
            {' '}
            trogiup@chotot.vn
          </a>
        </p>
      </div>
    </Drawer>;
};
const iconCss = "iyidwi2";
const containerCss = "c1tnpe3b";
const titleCss = "t956ht2";
export default BanPopup;

require("./BanPopup.linaria.module.css");